import React from 'react'
import PropTypes from 'prop-types'

class MobileMenuButton extends React.Component {
  constructor(props) {
    super(props)
  }

  /** TODO: This is bad. Update this when the header is being redone. */
  render() {
    return (
      <a onClick={() => this.props.onClick('Menu Button')}>
        <button className="navbar-toggle" type="button">
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>
      </a>
    )
  }
}

MobileMenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default MobileMenuButton
